import axiosInstance from './axiosInstance';

export async function scanApsPdf(file: File) {
    const formData = new FormData();
    formData.append('pdf', file);

    const response = await axiosInstance.post('/api/v1/ocr/aps', formData, {
        timeout: 120_000,
    });

    return response.data;
}
